import api from 'api';

export const WORKFLOWS_ASYNC_ACTION_START = 'WORKFLOWS_ASYNC_ACTION_START';
export const WORKFLOWS_ASYNC_ACTION_ERROR = 'WORKFLOWS_ASYNC_ACTION_ERROR';
export const WORKFLOWS_COMPLETE_PROCESSS_STEP_ASYNC_SUCCESS = 'WORKFLOWS_COMPLETE_PROCESSS_STEP_ASYNC_SUCCESS';
export const WORKFLOWS_UPDATE_ASYNC_ACTION_SUCCESS = 'WORKFLOWS_UPDATE_ACTION_SUCCESS';
export const WORKFLOWS_UPDATE_ACTION_ERROR = 'WORKFLOWS_UPDATE_ACTION_ERROR';
export const WORKFLOWS_RESET_STATE = 'WORKFLOWS_RESET_STATE';

export function updateWorkflowAsyncSuccess(data) {
  return {
    type: WORKFLOWS_UPDATE_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function updateWorkflowError(error) {
  return {
    type: WORKFLOWS_UPDATE_ACTION_ERROR,
    error,
  };
}

function workflowsAsyncStart() {
  return {
    type: WORKFLOWS_ASYNC_ACTION_START,
  };
}

function workflowsAsyncError(error) {
  return {
    type: WORKFLOWS_ASYNC_ACTION_ERROR,
    error,
  };
}

function updateProcessStepAsyncSuccess(data) {
  return {
    type: WORKFLOWS_COMPLETE_PROCESSS_STEP_ASYNC_SUCCESS,
    data,
  };
}

export function resetWorkflowsState() {
  return {
    type: WORKFLOWS_RESET_STATE,
  };
}

export function completeProcessStepAsync(id) {
  return (dispatch, getState) => {
    dispatch(workflowsAsyncStart());
    return api.request(`userProcessStep/completeStep/${ id }`, 'post')
    .then((data) => {
      dispatch(updateProcessStepAsyncSuccess(data));
    })
    .catch((err) => {
      dispatch(workflowsAsyncError('Unable to complete the workflow step'));
      throw (err);
    });
  };
}
